import { SecurityScanConclusionEnum } from '@repo/api-gw-sdk';

export const securityScanConclusionLabels: Partial<Record<string, string>> = {
  [SecurityScanConclusionEnum.HighChanceForRansomware]: 'Ransomware',
  [SecurityScanConclusionEnum.DataAnomalyDetected]: 'Anomalous activity',
  [SecurityScanConclusionEnum.MalwareDetected]: 'Malware',
};

export const securityScanConclusionOptions = Object.entries(
  securityScanConclusionLabels
).map(([id, name]) => ({
  id,
  name,
}));
